module.exports = __webpack_public_path__ + "media/assets/faria_products/AtlasNext_logo-f80c4f6c9dc1d96b4c8d881c6dfba1bee65508fa3fb0613629c607a8b3dfae91.png";